import { cx } from 'class-variance-authority';
import type { HTMLProps, PropsWithChildren } from 'react';

export interface LegalListProps
  extends HTMLProps<HTMLOListElement | HTMLUListElement> {
  readonly indent?: 'single' | 'double';
  readonly ordered?: boolean;
  readonly spacing?: 'single' | 'double';
}

const LegalList = ({
  children,
  className,
  indent = 'single',
  ordered = true,
  spacing = 'single',
}: PropsWithChildren<LegalListProps>) => {
  const ListEl = ordered ? 'ol' : 'ul';
  return (
    <ListEl
      className={cx(
        {
          '[&>li]:mb-4': spacing === 'double',
          'ml-4': indent === 'single',
          'ml-12': indent === 'double',
        },
        className,
      )}
      data-cy="legal-list"
    >
      {children}
    </ListEl>
  );
};

export default LegalList;
